import React, { useState, createRef } from 'react';
import { withSnackbar } from 'notistack';
import { ActivityIndicator, TextInput } from 'react-native';

import './style.scss';
import { ScreenTitle } from '../../../../components/atoms';
import { Strings } from '../../../../shared/constants/Constants';
import MessageModal from '../../../../components/molecules/MessageModal';
import { ROUTE_CONSTANTS } from '../../../../shared/constants/Route';

const ChangePassword = ({
  userId,
  sessionToken,
  changePassword,
  history,
  enqueueSnackbar,
  Logout = () => {
  },
}) => {
  const [values, setValues] = useState({
    oldPassword: '',
    newPassword: '',
    confirmNewPassword: '',
  });
  const [errors, setErrors] = useState({
    oldPasswordError: '',
    newPasswordError: '',
    confirmNewPasswordError: '',
  });
  const [loading, updateLoading] = useState(false);
  const [showModal, updateModal] = useState(false);
  const oldPasswordRef = createRef();
  const newPasswordRef = createRef();
  const confirmNewPasswordRef = createRef();

  const handleChange = (key, errorKey) => (newText) => {
    setValues({
      ...values,
      [key]: newText,
    });
    setErrors({
      ...errors,
      [errorKey]: '',
    });
  };

  const validate = (value, key, allErrors) => {
    // eslint-disable-next-line default-case
    switch (key) {
      case 'oldPassword': {
        if (!value) {
          return (allErrors.oldPasswordError = Strings.enterOldPassword);
        }
        return (allErrors.oldPasswordError = '');
      }
      case 'newPassword': {
        if (!value) {
          return (allErrors.newPasswordError = Strings.enterNewPassword);
        }
        return (allErrors.newPasswordError = '');
      }
      case 'confirmNewPassword': {
        if (!value) {
          return (allErrors.confirmNewPasswordError =
            Strings.confirmNewPassword);
        }
        if (value !== values.newPassword) {
          return (allErrors.confirmNewPasswordError =
            Strings.passwordsMismatch);
        }
        return (allErrors.confirmNewPasswordError = '');
      }
    }
  };

  const handleSubmit = () => {
    const { oldPassword, newPassword, confirmNewPassword } = values;
    const { oldPasswordError, newPasswordError } = errors;
    const allErrors = {
      oldPasswordError,
      newPasswordError,
      confirmNewPasswordError,
    };
    const arr = [{ oldPassword }, { newPassword }];
    arr.forEach((obj) =>
      validate(Object.values(obj)[0], Object.keys(obj)[0], allErrors),
    );
    if (allErrors.newPasswordError === '') {
      validate(confirmNewPassword, 'confirmNewPassword', allErrors);
    }
    setErrors({
      ...errors,
      ...allErrors,
    });

    if (
      !allErrors.newPasswordError &&
      !allErrors.oldPasswordError &&
      !allErrors.confirmNewPasswordError
    ) {
      updateLoading(true);
      const changePasswordRequestBody = {
        userId,
        sessionToken,
        password: newPassword,
        old_password: oldPassword,
      };
      changePassword(
        changePasswordRequestBody,
        () => {
          updateLoading(false);
          updateModal(true);
        },
        (message, type) => {
          updateLoading(false);
          enqueueSnackbar(message, {
            variant: type,
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
          });
        },
      );
    }
  };

  const handleInputSubmit = (key) => () => {
    const { oldPassword, newPassword } = values;
    if (key === 'oldPassword') {
      if (!oldPassword) {
        setErrors({
          ...errors,
          oldPasswordError: Strings.enterOldPassword,
        });
      } else {
        newPasswordRef.current.focus();
      }
    } else if (key === 'newPassword') {
      if (!newPassword) {
        setErrors({
          ...errors,
          newPasswordError: Strings.enterNewPassword,
        });
      } else {
        confirmNewPasswordRef.current.focus();
      }
    }
  };

  const { oldPassword, newPassword, confirmNewPassword } = values;
  const {
    oldPasswordError,
    newPasswordError,
    confirmNewPasswordError,
  } = errors;
  const errorStyle = { color: '#d11919', fontSize: 12, marginTop: '5px' };
  return (
    <>
      {showModal && (
        <MessageModal
          icon={'tick.png'}
          title={'Password Changed'}
          message={'Your password has been changed successfully. Please login again.'}
          color={'#fff'}
          marginH4={'2rem'}
          marginP={'0px'}
          callback={() => {
            history.replace(ROUTE_CONSTANTS.DASHBOARD);
            Logout();
            updateModal(false);
          }}
        />
      )}
      <ScreenTitle title='Dashboard' subTitle='Change Password'/>
      <form
        className='forgot-password-form'
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <div className='form-group'>
          <label>Old Password</label>
          {/* <input
            type="password"
            placeholder="************"
            ref={oldPasswordRef}
            value={oldPassword}
            // onBlur={handleInputSubmit("oldPassword")}
            onChange={handleChange("oldPassword", "oldPasswordError")}
          /> */}
          <TextInput
            secureTextEntry={true}
            placeholder='************'
            ref={oldPasswordRef}
            value={oldPassword}
            returnKeyType={'next'}
            autoCorrect={false}
            onChangeText={handleChange('oldPassword', 'oldPasswordError')}
            onSubmitEditing={handleInputSubmit('oldPassword')}
          />
          {oldPasswordError && <p style={errorStyle}>{oldPasswordError}</p>}
        </div>
        <div className='form-group'>
          <label>New Password</label>
          {/* <input
            type="password"
            placeholder="************"
            ref={newPasswordRef}
            value={newPassword}
            // onSubmit={handleInputSubmit("newPassword")}
            onChange={handleChange("newPassword", "newPasswordError")}
          /> */}
          <TextInput
            secureTextEntry={true}
            ref={newPasswordRef}
            placeholder='************'
            value={newPassword}
            returnKeyType={'next'}
            autoCorrect={false}
            onChangeText={handleChange('newPassword', 'newPasswordError')}
            onSubmitEditing={handleInputSubmit('newPassword')}
          />
          {newPasswordError && <p style={errorStyle}>{newPasswordError}</p>}
        </div>
        <div className='form-group'>
          <label>Confirm Password</label>
          {/* <input
            type="password"
            placeholder="************"
            ref={confirmNewPasswordRef}
            value={confirmNewPassword}
            // onSubmit={handleInputSubmit("confirmNewPassword")}
            onChange={handleChange("confirmNewPassword", "confirmNewPassword")}
          /> */}
          <TextInput
            secureTextEntry={true}
            ref={confirmNewPasswordRef}
            placeholder='************'
            value={confirmNewPassword}
            returnKeyType={'go'}
            autoCorrect={false}
            onChangeText={handleChange(
              'confirmNewPassword',
              'confirmNewPasswordError',
            )}
            onSubmitEditing={handleSubmit}
          />
          {confirmNewPasswordError && (
            <p style={errorStyle}>{confirmNewPasswordError}</p>
          )}
        </div>
        <div className='btn_wrap'>
          <button
            className='blue-btn mt-2'
            type='button'
            onClick={handleSubmit}
          >
            {loading ? (
              <ActivityIndicator color={'white'} size={'small'}/>
            ) : (
              'Save Password'
            )}
          </button>
        </div>
      </form>
    </>
  );
};

export default withSnackbar(ChangePassword);
